module.exports = __webpack_public_path__ + "img/club-thrive-logo.79a0eaa3.png";